// User service for fetching user data from API
import Cookies from 'js-cookie';

export interface UserApiResponse {
    status: string;
    message: string;
    data: {
        uuid: string;
        userName: string;
        userEmail: string;
        phone: string;
        team_uuid: string | null;
        user_active: boolean;
        email_notification: boolean;
        sms_notification: boolean;
        whatsapp_notifications: boolean;
        user_pause: boolean;
        created_at: string;
        updated_at: string;
        accounts_count?: number;
        role: {
            uuid: string;
            role_id: number;
            role_name: string;
            role_description: string;
            lead_scope: 'all' | 'team' | 'assigned' | 'none';
        };
        team: {
            uuid: string;
            team_name: string;
        };
        client?: {
            client_name: string;
        };
    };
}

export async function fetchCurrentUser(): Promise<UserApiResponse | null> {
    try {
        const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api';
        const token = Cookies.get('crm_auth_token');

        if (!token) {
            console.error('No authentication token found in cookies');
            return null;
        }

        const response = await fetch(`${apiUrl}/users/me`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            console.error('Failed to fetch user data:', response.status);
            return null;
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching user data:', error);
        return null;
    }
}